module.exports = __webpack_public_path__ + "files/0f29f3683df2307b03164b13df6399f9.png";